import React from 'react';
import { useTranslation } from 'react-i18next';
import { useClient } from '@context/presentation';
import { HighlightSection, ScriptHeader } from '../styles';
import { Line } from '@slides/styles';

export const SectionOne = () => {
    const { t } = useTranslation();
    const { firstName, lastName } = useClient();

    return (
        <>
            <ScriptHeader>
                {t('additional_info.script.title')}
            </ScriptHeader>
            <Line />
            <div>
                {t('additional_info.script.1')}
                <strong>{firstName} {lastName}</strong>
                {t('additional_info.script.2')}
             </div>
             <div>
               <strong>{t('additional_info.script.3')}</strong>
             </div>
           <div>
               {t('additional_info.script.4')}
            </div>
            <HighlightSection>
                <div>
                    <strong>{t('additional_info.script.rebuttal1.1')}</strong>
                    <p>{t('additional_info.script.rebuttal1.2')}</p>
                    <p>
                        {t('additional_info.script.rebuttal1.3')}
                        <strong>{t('additional_info.script.monthly_savings')}</strong>
                        {t('additional_info.script.rebuttal1.4')}
                        <strong>{t('additional_info.script.monthly_savings_10x')}</strong>
                        {t('additional_info.script.rebuttal1.5')}
                        <strong>{t('additional_info.script.monthly_savings_10x')}</strong>
                        {t('additional_info.script.rebuttal1.6')}
                    </p>
                    <p>{t('additional_info.script.rebuttal1.7')}</p>
                </div>
                <div>
                    <strong>{t('additional_info.script.rebuttal2.1')}</strong>
                   <p>{t('additional_info.script.rebuttal2.2')}</p>
                </div>
            </HighlightSection>
       </>
    );
};
